import React, { useState } from "react";
import { useFormContext } from "react-hook-form";
import Button from "../common/button";
import LottieAnimation from "../common/animations";
import ProgressBar from "../common/progress-bar";
import AnimatedDigit from "../common/animations/digit-animation";
import { KnowMore } from "../../icons/tags-icons";

const SocialsSuccessComp: React.FC = () => {
  const {
    formState: { isSubmitting },
  } = useFormContext();
  const [isInfoBoxOpen, setIsInfoBoxOpen] = useState(false);

  const handleToggleInfoBox = () => {
    setIsInfoBoxOpen(!isInfoBoxOpen);
  };

  return (
    <div className="h-full w-full flex flex-col justify-between relative overflow-y-auto">
      <div className="flex flex-row justify-between">
        <div className="w-32 md:mb-10 mb-6 float-left">
          <LottieAnimation lottieUrl="/animation/Logo.lottie" height="40px" />
        </div>

        <div className="mt-3 ml-4 w-1/5 float-right">
          <ProgressBar currentStep={5} totalSteps={5} />
        </div>
      </div>
      <div className="w-full">
        <LottieAnimation lottieUrl="/animation/congratulatory.lottie" />
      </div>

      <div className="flex flex-col items-center mt-10 mb-6 relative gap-10">
        <div className="relative flex flex-row mx-auto items-center rounded-full py-2 px-4 mb-4 ">
          <div className="absolute inset-0 z-0 transform scale-120">
            <LottieAnimation
              lottieUrl="/animation/bg-animation.lottie"
              height="100%"
              width="100%"
            />
          </div>

          <img
            src="/assets/icons/star-red.png"
            alt=""
            width={25}
            height={25}
            className="relative z-10"
          />

          <div className="flex flex-row text-xl font-bold ml-2 relative z-10">
            <AnimatedDigit digits={[1, 2]} direction="up" />
            <AnimatedDigit digits={[9, 8, 7, 6, 5]} direction="down" />
          </div>
        </div>

        {isInfoBoxOpen && (
          <div className="absolute bottom-10 w-full py-10 md:px-16 px-8 bg-[#262626] text-white rounded-lg z-50">
            <div className="flex flex-row mb-2">
              <img
                src="/assets/icons/star-red.png"
                alt=""
                className="w-6 h-6 object-fill mr-2"
              />
              <h3 className="text-lg font-semibold bg-gradient-text text-transparent bg-clip-text">
                What is XP?
              </h3>
            </div>
            <p className="text-sm">
              XP stands for Experience Points. It is a measure of your progress
              and achievements within our platform. The more XP you earn, the
              more benefits and recognition you gain.
            </p>
          </div>
        )}

        <div
          className="text-center text-[#EBEBEB] text-sm font-medium border rounded-lg px-2 mt-2 py-[2px] flex flex-row cursor-pointer"
          onClick={handleToggleInfoBox}
        >
          <div className="mr-2">
            <KnowMore />
          </div>
          What is XP?
        </div>
      </div>

      <Button
        isSubmitting={isSubmitting}
        customClasses="w-full mb-5 rounded-xl"
      >
        Next
      </Button>
    </div>
  );
};

export default SocialsSuccessComp;
